var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "table",
                  { staticClass: "important-table" },
                  [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticStyle: { width: "15%" },
                          attrs: { scope: "row" },
                        },
                        [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 重視順序 "),
                            _c("p", { staticClass: "en-text" }, [
                              _vm._v("Order of importance"),
                            ]),
                          ]),
                        ]
                      ),
                      _c("th", { attrs: { scope: "row" } }, [
                        _c("span", { style: { color: _vm.fontColor } }, [
                          _vm._v(" 項目 "),
                          _c("p", { staticClass: "en-text" }, [_vm._v("item")]),
                        ]),
                      ]),
                      _c("th", { attrs: { scope: "row" } }, [
                        _c("span", { style: { color: _vm.fontColor } }, [
                          _vm._v(" 重視原因 "),
                          _c("p", { staticClass: "en-text" }, [
                            _vm._v("Reason of importance"),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._l(_vm.workConsideration, function (data, index) {
                      return _c("tr", { key: index }, [
                        _c("th", { attrs: { scope: "row" } }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" " + _vm._s(++index) + " "),
                          ]),
                        ]),
                        _c(
                          "td",
                          [
                            _c("ValidationProvider", {
                              staticClass: "w-100",
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "w-100",
                                            attrs: { placeholder: "請選擇" },
                                            model: {
                                              value: data.Item,
                                              callback: function ($$v) {
                                                _vm.$set(data, "Item", $$v)
                                              },
                                              expression: "data.Item",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "產業發展 (Industrial Development)",
                                                value: 0,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "職務內容 (Job content)",
                                                value: 1,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "薪資待遇 (Salary)",
                                                value: 2,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "訓練制度 (Training system)",
                                                value: 3,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "公司福利 (Company benefit)",
                                                value: 4,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "企業形象 (Corporate image)",
                                                value: 5,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "工作環境 (Work environment)",
                                                value: 6,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "工作地點 (Work location)",
                                                value: 7,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "親友推薦 (Friend referral)",
                                                value: 8,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "其他 (Others)",
                                                value: 9,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        errors[0]
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(errors[0]) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: data.Reason,
                                expression: "data.Reason",
                              },
                            ],
                            attrs: {
                              type: "text",
                              maxlength: "50",
                              autocomplete: "off",
                              readonly: "",
                            },
                            domProps: { value: data.Reason },
                            on: {
                              focus: function ($event) {
                                return _vm.$common.removeReadonly($event)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(data, "Reason", $event.target.value)
                              },
                            },
                          }),
                        ]),
                      ])
                    }),
                  ],
                  2
                ),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveWorkConsideration)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }